import { render, staticRenderFns } from "./NbaSavedLineup.vue?vue&type=template&id=0724c58e&scoped=true"
import script from "./NbaSavedLineup.vue?vue&type=script&lang=js"
export * from "./NbaSavedLineup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0724c58e",
  null
  
)

export default component.exports